import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  Col,
  Container,
  Row,
  Tabs,
  Tab,
  Table,
  Accordion,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FetchStatus } from "src/Utils/getAppointmentStatus";
const PatientDetails = () => {
  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();

  return (
    <Container fluid>
      <Row className="mb-3">
        <Col xs={12}>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="text-info">
              <FontAwesomeIcon
                icon={faArrowLeft}
                onClick={() => {
                  navigate(-1);
                }}
                className="mx-2 cursor"
              />
              PATIENT DETAILS
            </h4>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Card className="rounded-lg border-0 shadow">
            <Card.Body>
              <Tabs
                defaultActiveKey="personalDetails"
                id="patient-details-tabs"
                className="mb-3"
              >
                <Tab eventKey="personalDetails" title="Personal Records">
                  <dl className="row mt-3">
                    <dt className="col-sm-4 col-lg-3 text-muted">Name:</dt>
                    <dd className="col-sm-8 col-lg-9">{state.Name_Surname}</dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">
                      Date Of Birth:
                    </dt>
                    <dd className="col-sm-8 col-lg-9">{state.DOB}</dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">
                      Place Of Birth:
                    </dt>
                    <dd className="col-sm-8 col-lg-9">
                      {state.Place_of_birth}
                    </dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">
                      TaxID code:
                    </dt>
                    <dd className="col-sm-8 col-lg-9">{state.TaxIDcode}</dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">Domicile:</dt>
                    <dd className="col-sm-8 col-lg-9">{state.Domicile}</dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">Residence:</dt>
                    <dd className="col-sm-8 col-lg-9">{state.Residence}</dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">
                      Mobilephone:
                    </dt>
                    <dd className="col-sm-8 col-lg-9">{state.Mobilephone}</dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">Mail:</dt>
                    <dd className="col-sm-8 col-lg-9">{state.mail}</dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">Children:</dt>
                    <dd className="col-sm-8 col-lg-9">
                      {state.Children.has_children}
                    </dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">
                      Children Gender:
                    </dt>
                    <dd className="col-sm-8 col-lg-9">
                      {state.Children.children_gender}
                    </dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">
                      Marital Status:
                    </dt>
                    <dd className="col-sm-8 col-lg-9">{state.Maritalstatus}</dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">
                      Brother/Sisters:
                    </dt>
                    <dd className="col-sm-8 col-lg-9">
                      {state.Brother_sisters.have_brothers_sisters}
                    </dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">
                      How Many Brothers /Sisters:
                    </dt>
                    <dd className="col-sm-8 col-lg-9">
                      {state.Brother_sisters.how_many_brothers_sisters}
                    </dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">
                      Parents Alive:
                    </dt>
                    <dd className="col-sm-8 col-lg-9">
                      {state.Parents_alive.isParentsAlive}
                    </dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">
                      Qualification:
                    </dt>
                    <dd className="col-sm-8 col-lg-9">{state.Qualification}</dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">
                      Profession:
                    </dt>
                    <dd className="col-sm-8 col-lg-9">{state.Profession}</dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">
                      ASL Assistance:
                    </dt>
                    <dd className="col-sm-8 col-lg-9">
                      {state.ASL_assistance}
                    </dd>
                    <dt className="col-sm-4 col-lg-3 text-muted">
                      Practitioner Name:
                    </dt>
                    <dd className="col-sm-8 col-lg-9">
                      {state.General_Practitioner_Name}
                    </dd>
                  </dl>
                </Tab>
                <Tab eventKey="healthRecords" title="Health Records">
                  {state.Health_Records ? (
                    <div>
                      <dl className="row mt-3">
                        <dt className="col-sm-4 col-lg-3 text-muted">Age:</dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.Health_Records.Age}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Weight:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.Health_Records.Weight}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Height:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.Health_Records.Height}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Allergies:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.Health_Records.Allergies}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Vaccinations:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.Health_Records.Vaccinations}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Medications Taken:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.Health_Records.medicationsTaken}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Emergency Room Visit:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.Health_Records.emergencyRoomVisit}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Surgical Intervention:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.Health_Records.surgicalIntervention}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Last BP Reading:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.Health_Records.LastBP.bp_reading}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          BP Last Measured:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.Health_Records.LastBP.bp_last_measured}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Last Heart Reading:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.Health_Records.LastHeartRate.hr_reading}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Heart Rate Last Measured:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.Health_Records.LastHeartRate.hr_last_measured}
                        </dd>
                      </dl>
                      <Accordion>
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            Pathological Details
                          </Accordion.Header>
                          {state.Health_Records.PathologicalSection &&
                          state.Health_Records.PathologicalSection.length >
                            0 ? (
                            state.Health_Records.PathologicalSection.map(
                              (pathology, index) => (
                                <Accordion.Body key={index}>
                                  <dl className="row">
                                    <dt className="col-sm-4 col-lg-3 text-muted">
                                      Pathology Description:
                                    </dt>
                                    <dd className="col-sm-8 col-lg-9">
                                      {pathology.Pathology_Descr}
                                    </dd>
                                    <dt className="col-sm-4 col-lg-3 text-muted">
                                      Certification Date:
                                    </dt>
                                    <dd className="col-sm-8 col-lg-9">
                                      {pathology.CertifDate}
                                    </dd>
                                    <dt className="col-sm-4 col-lg-3 text-muted">
                                      Status:
                                    </dt>
                                    <dd className="col-sm-8 col-lg-9">
                                      {pathology.Status}
                                    </dd>
                                    <dt className="col-sm-4 col-lg-3 text-muted">
                                      Certification Document:
                                    </dt>
                                    <dd className="col-sm-8 col-lg-9">
                                      {pathology.CertifDoc}
                                    </dd>
                                  </dl>
                                </Accordion.Body>
                              )
                            )
                          ) : (
                            <p className="text-center font-bold">
                              No Pathological Records Available
                            </p>
                          )}
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                          <Accordion.Header>
                            Pediatrical Details
                          </Accordion.Header>
                          {state.Health_Records.PediatricalSection ? (
                            <Accordion.Body>
                              <dl className="row">
                                <dt className="col-sm-4 col-lg-3 text-muted">
                                  GenhealthInfo:
                                </dt>
                                <dd className="col-sm-8 col-lg-9">
                                  {
                                    state.Health_Records.PediatricalSection
                                      .GenhealthInfo
                                  }
                                </dd>
                                <dt className="col-sm-4 col-lg-3 text-muted">
                                  Height:
                                </dt>
                                <dd className="col-sm-8 col-lg-9">
                                  {
                                    state.Health_Records.PediatricalSection
                                      .Height
                                  }
                                </dd>
                                <dt className="col-sm-4 col-lg-3 text-muted">
                                  Weight:
                                </dt>
                                <dd className="col-sm-8 col-lg-9">
                                  {
                                    state.Health_Records.PediatricalSection
                                      .Weight
                                  }
                                </dd>
                                <dt className="col-sm-4 col-lg-3 text-muted">
                                  DevelopmentalMilestones:
                                </dt>
                                <dd className="col-sm-8 col-lg-9">
                                  {
                                    state.Health_Records.PediatricalSection
                                      .DevelopmentalMilestones
                                  }
                                </dd>
                                <Accordion>
                                  <Accordion.Item eventKey="sub1">
                                    <Accordion.Header>
                                      Vaccination Records
                                    </Accordion.Header>
                                    {state.Health_Records.PediatricalSection.Vaccination_Records.map(
                                      (vaccine) => (
                                        <Accordion.Body>
                                          <dt className="col-sm-4 col-lg-3 text-muted">
                                            VaccineName:
                                          </dt>
                                          <dd className="col-sm-8 col-lg-9">
                                            {vaccine.vaccineName}
                                          </dd>
                                          <dt className="col-sm-4 col-lg-3 text-muted">
                                            Vaccination Date:
                                          </dt>
                                          <dd className="col-sm-8 col-lg-9">
                                            {vaccine.vaccinationDate}
                                          </dd>
                                        </Accordion.Body>
                                      )
                                    )}
                                  </Accordion.Item>
                                </Accordion>
                              </dl>
                            </Accordion.Body>
                          ) : (
                            <p className="text-center font-bold">
                              No Pediatrical Records Available
                            </p>
                          )}
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                          <Accordion.Header>
                            Vetirinary Details
                          </Accordion.Header>
                          {state.Health_Records.VetirinarySection ? (
                            <Accordion.Body>
                              <dl className="row">
                                <dt className="col-sm-4 col-lg-3 text-muted">
                                  Animal_Species:
                                </dt>
                                <dd className="col-sm-8 col-lg-9">
                                  {
                                    state.Health_Records.VetirinarySection
                                      .Animal_Species
                                  }
                                </dd>
                                <dt className="col-sm-4 col-lg-3 text-muted">
                                  Breed:
                                </dt>
                                <dd className="col-sm-8 col-lg-9">
                                  {state.Health_Records.VetirinarySection.Breed}
                                </dd>
                                <dt className="col-sm-4 col-lg-3 text-muted">
                                  GenhealthInfo:
                                </dt>
                                <dd className="col-sm-8 col-lg-9">
                                  {
                                    state.Health_Records.VetirinarySection
                                      .GenhealthInfo
                                  }
                                </dd>
                                <dt className="col-sm-4 col-lg-3 text-muted">
                                  MedicalHistory:
                                </dt>
                                <dd className="col-sm-8 col-lg-9">
                                  {
                                    state.Health_Records.VetirinarySection
                                      .MedicalHistory
                                  }
                                </dd>
                                <Accordion>
                                  <Accordion.Item eventKey="sub2">
                                    <Accordion.Header>
                                      Vaccination Records
                                    </Accordion.Header>
                                    {state.Health_Records.VetirinarySection.Vaccination_Records.map(
                                      (vaccine) => (
                                        <Accordion.Body>
                                          <dt className="col-sm-4 col-lg-3 text-muted">
                                            VaccineName
                                          </dt>
                                          <dd className="col-sm-8 col-lg-9">
                                            {vaccine.vaccineName}
                                          </dd>
                                          <dt className="col-sm-4 col-lg-3 text-muted">
                                            Vaccination Date
                                          </dt>
                                          <dd className="col-sm-8 col-lg-9">
                                            {vaccine.vaccinationDate}
                                          </dd>
                                        </Accordion.Body>
                                      )
                                    )}
                                  </Accordion.Item>
                                </Accordion>
                              </dl>
                            </Accordion.Body>
                          ) : (
                            <p className="text-center font-bold">
                              No Vetirinary Records Available
                            </p>
                          )}
                        </Accordion.Item>
                        <Accordion.Item eventKey="3">
                          <Accordion.Header>
                            Specific Organ Diagnosis Records
                          </Accordion.Header>
                          {state.Health_Records.SpecificOrganDiagnosis ? (
                            <Accordion.Body>
                              <dl className="row">
                                <dt className="col-sm-4 col-lg-3 text-muted">
                                  Organ_System:
                                </dt>
                                <dd className="col-sm-8 col-lg-9">
                                  {
                                    state.Health_Records.SpecificOrganDiagnosis
                                      .Organ_System
                                  }
                                </dd>
                                <dt className="col-sm-4 col-lg-3 text-muted">
                                  PathologyDescr:
                                </dt>
                                <dd className="col-sm-8 col-lg-9">
                                  {
                                    state.Health_Records.SpecificOrganDiagnosis
                                      .PathologyDescr
                                  }
                                </dd>
                                <dt className="col-sm-4 col-lg-3 text-muted">
                                  DtOfDiagnosis:
                                </dt>
                                <dd className="col-sm-8 col-lg-9">
                                  {
                                    state.Health_Records.SpecificOrganDiagnosis
                                      .DtOfDiagnosis
                                  }
                                </dd>
                                <dt className="col-sm-4 col-lg-3 text-muted">
                                  TreatmentHistory:
                                </dt>
                                <dd className="col-sm-8 col-lg-9">
                                  {
                                    state.Health_Records.SpecificOrganDiagnosis
                                      .TreatmentHistory
                                  }
                                </dd>
                                <dt className="col-sm-4 col-lg-3 text-muted">
                                  CurrentStat:
                                </dt>
                                <dd className="col-sm-8 col-lg-9">
                                  {
                                    state.Health_Records.SpecificOrganDiagnosis
                                      .CurrentStat
                                  }
                                </dd>
                              </dl>
                            </Accordion.Body>
                          ) : (
                            <p className="text-center font-bold">
                              No Organ Diagnosis Records Available
                            </p>
                          )}
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  ) : (
                    <p>No health records available.</p>
                  )}
                </Tab>
                <Tab eventKey="appointments" title="Appointments">
                  {state.Appointments.length > 0 ? (
                    <Table responsive bordered22 hover>
                      <thead>
                        <tr>
                          <th>Doctor Name</th>
                          <th>Doctor Speciality</th>
                          <th>Appointment Type</th>
                          <th>Appointment Date</th>
                          <th>Appointment Time </th>
                          <th>Status</th>
                        </tr>
                      </thead>

                      <tbody>
                        {state.Appointments?.map((itx, index) => (
                          <tr key={index}>
                            <td>{itx.dr_name}</td>
                            <td>{itx.dr_speciality}</td>
                            <td>{itx.appointment_type}</td>
                            <td>{itx.appointment_date}</td>
                            <td>{itx.appointment_time}</td>
                            <td
                              className={
                                FetchStatus(
                                  itx.appointment_date,
                                  itx.appointment_time
                                ) == "upcoming"
                                  ? "upcoming-status-txt"
                                  : FetchStatus(
                                      itx.appointment_date,
                                      itx.appointment_time
                                    ) == "ongoing"
                                  ? "ongoing-status-txt"
                                  : "past-status-txt"
                              }
                            >
                              {FetchStatus(
                                itx.appointment_date,
                                itx.appointment_time
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <p className="text-center"> No Appointments Found !</p>
                  )}
                </Tab>
              </Tabs>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PatientDetails;
